import protocolLauncher from './launcher/protocol.launcher';
import {resolveBridgeType, BridgeType} from './BridgeApi';

export interface ProtocolBridge {
    navigateToUe(): Promise<boolean>;
    openAddFriends(): Promise<boolean>;
    openAddFriendRequests(): Promise<boolean>;
    openAddFriendSuggestions(): Promise<boolean>;
    openAddFriendConnections(): Promise<boolean>;
    openSettings(): Promise<boolean>;
    openSocialPanel(): Promise<boolean>;
}

const bridges = {
    [BridgeType.LAUNCHER]: protocolLauncher,
    [BridgeType.WEB]: protocolLauncher,
    [BridgeType.MOCK]: protocolLauncher
};

export default (): ProtocolBridge => bridges[resolveBridgeType()];
